
































import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@fortawesome/fontawesome-free/css/all.css";

import { Component, Vue } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import {
    AppActionTypes,
    SetValidationRules,
    SetSettings,
    AppGetterTypes
} from "./store";

@Component
export default class App extends Vue {
    loading = true;

    @Getter(AppGetterTypes.pageTitle)
    pageTitle?: string;

    @Action(AppActionTypes.getValidationRules)
    getValidationRules!: SetValidationRules;

    @Action(AppActionTypes.getSettings)
    getSettings!: SetSettings;

    @Getter(AppGetterTypes.version)
    version!: string;

    @Getter(AppGetterTypes.genericOrderFailedMessage)
    genericOrderFailedMessage!: string;

    errorMessage: string | null = null;

    get hasError(): boolean {
        return !!this.errorMessage;
    }

    mounted(): void {
        this.$root.$on("error", this.handleError);

        // get validations rules from the api and set in the Vuex store
        const rulesPromise = this.getValidationRules();

        // get application version from the api and set in the Vuex store
        const versionPromise = this.getSettings();

        Promise.all([rulesPromise, versionPromise]).then(() => {
            this.loading = false;
        });
    }

    /** Take an action to notify the user according to our UX standards (see link above this code example). */
    handleError(): void {
        // Set the error message to display to the user
        this.errorMessage = this.genericOrderFailedMessage;
    }
}
